module.exports = __webpack_public_path__ + "static/media/lounge2.34570695.jpg";